<div
    class="w-full h-full flex flex-row items-center justify-between px-1.5 rounded-lg group"
    [ngClass]="{ 'cursor-pointer': isSelectable }">
    @if (partnerInfo.partner) {
        <fm-avatar
            size="md"
            [pTooltip]="tooltipContent"
            tooltipPosition="left"
            [tooltipOptions]="tooltipOptions"
            [isSaved]="partnerInfo.partner?.saved"
            [isQuietMode]="partnerInfo.partner?.preferences.quietMode.value"
            [avatarLocation]="partnerInfo.partner?.profilePhoto" />

        <ng-template #tooltipContent>
            <app-profile-preview
                [data]="partnerInfo"
                (profilePreviewMouseLeave)="onProfilePreviewMouseLeave($event)"
                (profilePreviewMouseEnter)="
                    onProfilePreviewMouseEnter($event)
                "></app-profile-preview>
        </ng-template>
    }
    @if (hasDirectBookablePartner) {
        <p-button
            class="ml-auto"
            (click)="onClickSendTimeslotPartnersToDynamicPanel()"
            severity="secondary"
            icon="pi pi-star-fill"
            styleClass="!w-6" />
    }
</div>
